import { Injectable, Inject } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { DOCUMENT } from "@angular/common";
import { ProductService } from "../../products/product.service";
import * as i18nIsoCountries from "i18n-iso-countries";
declare const require;
declare var $:any;
@Injectable()
export class SeoService {
  private indexHTML = {
    "title-en-us":
      "Buy Graphics Cards, Laptops, and Systems | NVIDIA Marketplace",
    "description-en-us":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-en-us":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-us":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    
      "title-en-in":
      "NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop – India",
    "description-en-in":
      "Shop NVIDIA GeForce graphics cards, gaming laptops, desktop and monitor from the official NVIDIA GeForce store - India. Know more about GeForce RTX 40 series GPUs. ",
    "title-compare-en-in":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-in":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    
      "title-vi-vn":
      "Mua card màn hình, laptop và máy bộ PC | NVIDIA GeForce Store Việt Nam",
    "description-vi-vn":
      "Mua card màn hình NVIDIA GeForce, Laptop Gaming, Máy tính để bàn, Laptop Studio và nhiều món khác từ cửa hàng NVIDIA Store chính thức. Hãy chọn mua ngay các dòng card đồ họa thế hệ RTX 40 series, 30 series, 20 series, GTX 16 series ở đây.",
    "title-compare-vi-vn":
      "So sánh mua card màn hình, laptop và máy bộ PC | NVIDIA GeForce Store Việt Nam",
    "description-compare-vi-vn":
      "Mua card màn hình NVIDIA GeForce, Laptop Gaming, Máy tính để bàn, Laptop Studio và nhiều món khác từ cửa hàng NVIDIA Store chính thức. Hãy chọn mua ngay các dòng card đồ họa thế hệ RTX 40 series, 30 series, 20 series, GTX 16 series ở đây.",

      "title-id-id":
      "Beli Kartu Grafis, Laptop, dan Sistem | NVIDIA GeForce Store Indonesia",
    "description-id-id":
      "Beli Kartu Grafis, Laptop Gaming, Desktop, Studio Laptop NVIDIA GeForce dan lainnya dari Toko resmi NVIDIA. Beli produk RTX 40 series, 30 series, 20 series, GTX 16 series sekarang.",
    "title-compare-id-id":
      "Membandingkan Beli Kartu Grafis, Laptop, dan Sistem | NVIDIA GeForce Store Indonesia",
    "description-compare-id-id":
      "Beli Kartu Grafis, Laptop Gaming, Desktop, Studio Laptop NVIDIA GeForce dan lainnya dari Toko resmi NVIDIA. Beli produk RTX 40 series, 30 series, 20 series, GTX 16 series sekarang.",


      "title-en-ph":
      "Buy Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store",
    "description-en-ph":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-en-ph":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-ph":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-en-ca": "Buy GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-en-ca":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-en-ca":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-ca":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-fr-ca":
      "Achetez des cartes graphiques GeForce RTX | Boutique NVIDIA GeForce",
    "description-fr-ca":
      "Découvrez GeForce RTX. Jouez avec la technologie de ray tracing en temps réel des GeForce RTX 2080 Ti, 2080 et 2070.",
    "title-compare-fr-ca":
      "Comparez les cartes graphiques GeForce RTX | Boutique NVIDIA GeForce",
    "description-compare-fr-ca":
      "Découvrez GeForce RTX. Jouez avec la technologie de ray tracing en temps réel des GeForce RTX 2080 Ti, 2080 et 2070.",
    "title-en-au": "Buy GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-en-au":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-en-au":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-au":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-en-gb": "Buy GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-en-gb":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-en-gb":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-gb":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-pt-br":
      "Placas de Vídeo, Notebooks Gamer e PCs Gamer NVIDIA GeForce - Brasil",
    "description-pt-br":
      "Encontre os melhores produtos e compre placas de vídeo, notebooks, PCs gamer e monitores NVIDIA GeForce na loja oficial da NVIDIA GeForce no Brasil. Conheça mais sobre as placas de vídeo NVIDIA GeForce RTX Série 40. ",
    "title-compare-pt-br":
      "Placas de Vídeo, Notebooks Gamer e PCs Gamer NVIDIA GeForce - Brasil",
    "description-compare-pt-br":
      "Encontre os melhores produtos e compre placas de vídeo, notebooks, PCs gamer e monitores NVIDIA GeForce na loja oficial da NVIDIA GeForce no Brasil. Conheça mais sobre as placas de vídeo NVIDIA GeForce RTX Série 40. ",
    "title-fr-fr":
      "Achetez des cartes graphiques GeForce RTX | Boutique NVIDIA GeForce",
    "description-fr-fr":
      "Découvrez GeForce RTX. Jouez avec la technologie de ray tracing en temps réel des GeForce RTX 2080 Ti, 2080 et 2070.",
    "title-compare-fr-fr":
      "Comparez les cartes graphiques GeForce RTX | Boutique NVIDIA GeForce",
    "description-compare-fr-fr":
      "Découvrez GeForce RTX. Jouez avec la technologie de ray tracing en temps réel des GeForce RTX 2080 Ti, 2080 et 2070.",
    "title-de-de": "GeForce RTX-Grafikkarten kaufen | NVIDIA GeForce Store",
    "description-de-de":
      "GeForce RTX ist da. Einfach losspielen mit GeForce RTX 2080 Ti, 2080 oder 2070 und Echtzeit-Raytracing-Technologie",
    "title-compare-de-de":
      "GeForce RTX-Grafikkarten vergleichen | NVIDIA GeForce Store",
    "description-compare-de-de":
      "GeForce RTX ist da. Einfach losspielen mit GeForce RTX 2080 Ti, 2080 oder 2070 und Echtzeit-Raytracing-Technologie.",
    "title-de-at": "GeForce RTX-Grafikkarten kaufen | NVIDIA GeForce Store",
    "description-de-at":
      "GeForce RTX ist da. Einfach losspielen mit GeForce RTX 2080 Ti, 2080 oder 2070 und Echtzeit-Raytracing-Technologie",
    "title-compare-de-at":
      "GeForce RTX-Grafikkarten vergleichen | NVIDIA GeForce Store",
    "description-compare-de-at":
      "GeForce RTX ist da. Einfach losspielen mit GeForce RTX 2080 Ti, 2080 oder 2070 und Echtzeit-Raytracing-Technologie.",
    "title-es-es":
      "Compra tarjetas gráficas GeForce RTX | Tienda NVIDIA GeForce",
    "description-es-es":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "title-compare-es-es":
      "Compara las tarjetas gráficas GeForce RTX | Tienda NVIDIA GeForce",
    "description-compare-es-es":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "title-es-mx":
      "Compra tarjetas gráficas GeForce RTX | Tienda NVIDIA GeForce",
    "description-es-mx":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "title-compare-es-mx":
      "Compara las tarjetas gráficas GeForce RTX | Tienda NVIDIA GeForce",
    "description-compare-es-mx":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "title-pl-pl": "Kup kartę graficzną GeForce RTX | Sklep NVIDIA GeForce",
    "description-pl-pl":
      "Karty GeForce RTX są już dostępne. Graj na kartach graficznych GeForce RTX 2080 Ti, 2080 i 2070, ciesząc się obsługą ray tracingu w czasie rzeczywistym.",
    "title-compare-pl-pl":
      "Porównaj karty graficzne GeForce RTX | Sklep NVIDIA GeForce",
    "description-compare-pl-pl":
      "Karty GeForce RTX są już dostępne. Graj na kartach graficznych GeForce RTX 2080 Ti, 2080 i 2070, ciesząc się obsługą ray tracingu w czasie rzeczywistym.",
    "title-nl-nl": "Buy GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-nl-nl":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-compare-nl-nl":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-nl-nl":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",
    "title-ru-ru": "Купить видеокарты GeForce RTX | Магазин NVIDIA GeForce",
    "description-ru-ru":
      "GeForce RTX уже здесь. Играйте на видеокартах GeForce RTX 2080 Ti, 2080 и 2070 с технологией трассировки лучей в реальном времени.",
    "title-compare-ru-ru":
      "Сравнить видеокарты GeForce RTX | Магазин NVIDIA GeForce",
    "description-compare-ru-ru":
      "GeForce RTX уже здесь. Играйте на видеокартах GeForce RTX 2080 Ti, 2080 и 2070 с технологией трассировки лучей в реальном времени.",
    "title-it-it":
      "Schede grafiche GeForce - La soluzione definitiva per il PC Gaming",
    "description-it-it":
      "Le schede grafiche NVIDIA GeForce sono state concepite per offrire la migliore esperienza di gioco su PC in assoluto e offrono prestazioni spettacolari, 3D immersivo e grafica in alta risoluzione.",
    "title-compare-it-it":
      "Schede grafiche GeForce - La soluzione definitiva per il PC Gaming",
    "description-compare-it-it":
      "Le schede grafiche NVIDIA GeForce sono state concepite per offrire la migliore esperienza di gioco su PC in assoluto e offrono prestazioni spettacolari, 3D immersivo e grafica in alta risoluzione.",
    "title-zh-tw": "購買顯示卡、筆記型電腦、桌上型電腦  | NVIDIA GeForce Store",
    "description-zh-tw":
      "GeForce RTX 來了。使用由Ampere 架構支援的GeForce RTX 30系列暢玩遊戲。",
    "title-compare-zh-tw": "比较 GeForce RTX 显卡 | NVIDIA GeForce Store",
    "description-compare-zh-tw":
      "GeForce RTX 來了。使用由Ampere 架構支援的GeForce RTX 30系列暢玩遊戲。",

    "title-en-sg":
      "Shop GeForce Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store SG",
    "description-en-sg":
      "Buy NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop, Studio Laptops and more from the official NVIDIA Store. Shop RTX 40 series, 30 series, 20 series, GTX 16 series products now.",
    "title-compare-en-sg":
      "Shop GeForce Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store SG",
    "description-compare-en-sg":
      "Buy NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop, Studio Laptops and more from the official NVIDIA Store. Shop RTX 40 series, 30 series, 20 series, GTX 16 series products now.",

    "title-fi-fi":
      "GEFORCE-NÄYTÖNOHJAINTEN, -KANNETTAVIEN JA -KONEIDEN VALIKOIMA - NVIDIA GeForce Store FI",
    "description-fi-fi":
      "Osta NVIDIA GeForce RTX 40 -sarjan tuotteita, 30-sarja, 20-sarjan ja GTX 16 -sarjan näytönohjaimet, pelikannettavat, pöytäkoneet ja muut.",
    "title-compare-fi-fi":
      "Vertaa GeForce RTX -näytönohjainkortteja | NVIDIA GeForce Store",
    "description-compare-fi-fi":
      "Osta NVIDIA GeForce RTX 40 -sarjan tuotteita, 30-sarja, 20-sarjan ja GTX 16 -sarjan näytönohjaimet, pelikannettavat, pöytäkoneet ja muut.",

    "title-da-dk":
      "KØB GRAFIKKORT, BÆRBARE PC'ER OG SYSTEMER MED GEFORCE - NVIDIA GeForce Store DK",
    "description-da-dk":
      "Køb grafikkort, bærbare gaming-pc’er, stationære pc’er m.m. i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "title-compare-da-dk":
      "Sammenlign GeForce RTX grafikkort | NVIDIA GeForce Store",
    "description-compare-da-dk":
      "Køb grafikkort, bærbare gaming-pc’er, stationære pc’er m.m. i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",

    "title-nb-no":
      "KJØP GRAFIKKORT, BÆRBARE PC-ER OG SYSTEMER FRA GEFORCE - NVIDIA GeForce Store NO",
    "description-nb-no":
      "Kjøp grafikkort, bærbare og stasjonære spill-PC-er og mer i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "title-compare-nb-no":
      "Sammenlign GeForce RTX grafikkort | NVIDIA GeForce Store",
    "description-compare-nb-no":
      "Kjøp grafikkort, bærbare og stasjonære spill-PC-er og mer i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",

    "title-sv-se":
      "KÖP GEFORCE-GRAFIKKORT, BÄRBARA DATORER OCH SYSTEM - NVIDIA GeForce Store SE",
    "description-sv-se":
      "Köp grafikkort i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien och i GTX 16-serien, bärbara och stationära speldatorer och mycket mer.",
    "title-compare-sv-se":
      "Jämför GeForce RTX grafikkort | NVIDIA GeForce Store",
    "description-compare-sv-se":
      "Köp grafikkort i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien och i GTX 16-serien, bärbara och stationära speldatorer och mycket mer.",

    "title-th-th":
      "ซื้อกราฟิกการ์ด แล็ปท็อป และเดสก์ท็อป | NVIDIA GeForce Store ประเทศไทย",
    "description-th-th":
      "ซื้อกราฟิกการ์ด NVIDIA GeForce เกมมิ่งแล็ปท็อป เดสก์ท็อป สตูดิโอแล็ปท็อป และอื่นๆ อีกมากมายจากร้าน NVIDIA Store เลือกซื้อสินค้า RTX 40 ซีรีส์, 30 ซีรีส์, 20 ซีรีส์, และ GTX 16 ซีรีส์ ได้ที่นี่",
    "title-compare-th-th": "",
    "description-compare-th-th":
      "ซื้อกราฟิกการ์ด NVIDIA GeForce เกมมิ่งแล็ปท็อป เดสก์ท็อป สตูดิโอแล็ปท็อป และอื่นๆ อีกมากมายจากร้าน NVIDIA Store เลือกซื้อสินค้า RTX 40 ซีรีส์, 30 ซีรีส์, 20 ซีรีส์, และ GTX 16 ซีรีส์ ได้ที่นี่",

    "title-en-my":
      "Buy Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store – Malaysia",
    "description-en-my":
      "Buy GeForce Graphics Cards, Laptops, Desktop, Monitor, and Mice NVIDIA Store – Malaysia. Checkout our all-new range of GeForce products now!",
    "title-compare-en-my":
      "Compare GeForce RTX Graphics Cards | NVIDIA GeForce Store",
    "description-compare-en-my":
      "GeForce RTX is here. Game on with GeForce RTX 2080 Ti, 2080 and 2070 with Real Time Ray Tracing technology.",

    "title-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 – 대한민국",
    "description-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 및 모니터를 NVIDIA GeForce 공식 스토어에서 구매하세요 - 대한민국. GeForce RTX 40 시리즈 GPU 에 대해 더 알아보세요",
    "title-compare-ko-kr":
      "GeForce RTX 그래픽 카드 비교하기 ㅣ NVIDIA GeForce 스토어",
    "description-compare-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 및 모니터를 NVIDIA GeForce 공식 스토어에서 구매하세요 - 대한민국. GeForce RTX 40 시리즈 GPU 에 대해 더 알아보세요",

    "title-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ノートパソコン、デスクトップ – 日本",
    "description-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ラップトップ、デスクトップ、モニターを NVIDIA GeForce 公式ストアから購入します。 GeForce RTX 40 シリーズ GPU の詳細については、こちらをご覧ください。",
    "title-compare-ja-jp":
      "GeForce RTXグラフィックカードを比較するㅣNVIDIA GeForceストア",
    "description-compare-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ラップトップ、デスクトップ、モニターを NVIDIA GeForce 公式ストアから購入します。 GeForce RTX 40 シリーズ GPU の詳細については、こちらをご覧ください。",
  };

  private configOG = {
    name: "NVIDIA",
    type: "product",
    image:
      "https://store.nvidia.com/en-us/assets/images/carousel/geforce-ada-4090-background-image-spec2-bb300_300-l.jpg",
    "title-en-us": "Introducing GeForce RTX Graphics Cards",
    "description-en-us":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-en-us": "https://store.nvidia.com/en-us/geforce/store/",

    "title-en-in":
      "NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop – India",
    "description-en-in":
      "Shop NVIDIA GeForce graphics cards, gaming laptops, desktop and monitor from the official NVIDIA GeForce store - India. Know more about GeForce RTX 40 series GPUs.",
    "url-en-in":
      "ttps://store.nvidia.com/en-in/geforce/store/?page=1&limit=9&locale=en-in",

      
    "title-id-id": "Beli Kartu Grafis, Laptop, dan Sistem | NVIDIA GeForce Store Indonesia",
    "description-id-id":
      "Beli Kartu Grafis, Laptop Gaming, Desktop, Studio Laptop NVIDIA GeForce dan lainnya dari Toko resmi NVIDIA. Beli produk RTX 40 series, 30 series, 20 series, GTX 16 series sekarang.",
    "url-id-id": "https://store.nvidia.com/id-id/geforce/store/?page=1&limit=9&locale=id-id",

    "title-vi-vn": "Mua card màn hình, laptop và máy bộ PC | NVIDIA GeForce Store Việt Nam",
    "description-vi-vn":
      "Mua card màn hình NVIDIA GeForce, Laptop Gaming, Máy tính để bàn, Laptop Studio và nhiều món khác từ cửa hàng NVIDIA Store chính thức. Hãy chọn mua ngay các dòng card đồ họa thế hệ RTX 40 series, 30 series, 20 series, GTX 16 series ở đây.",
    "url-vi-vn": "https://store.nvidia.com/vi-vn/geforce/store/",

    "title-th-th":
      "ซื้อกราฟิกการ์ด แล็ปท็อป และเดสก์ท็อป | NVIDIA GeForce Store ประเทศไทย",
    "description-th-th":
      "ซื้อกราฟิกการ์ด NVIDIA GeForce เกมมิ่งแล็ปท็อป เดสก์ท็อป สตูดิโอแล็ปท็อป และอื่นๆ อีกมากมายจากร้าน NVIDIA Store เลือกซื้อสินค้า RTX 40 ซีรีส์, 30 ซีรีส์, 20 ซีรีส์, และ GTX 16 ซีรีส์ ได้ที่นี่",
    "url-th-th":
      "https://store.nvidia.com/th-th/geforce/store/?page=1&limit=9&locale=th-th",

    "title-en-ph": "Introducing GeForce RTX Graphics Cards",
    "description-en-ph":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-en-ph": "https://store.nvidia.com/en-ph/geforce/store/",

    "title-en-ca": "Introducing GeForce RTX Graphics Cards",
    "description-en-ca":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-en-ca": "https://store.nvidia.com/en-ca/geforce/store/",

    "title-en-au": "Introducing GeForce RTX Graphics Cards",
    "description-en-au":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-en-au": "https://store.nvidia.com/en-au/geforce/store/",

    "title-en-gb": "Introducing GeForce RTX Graphics Cards",
    "description-en-gb":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-en-gb": "https://store.nvidia.com/en-gb/geforce/store/",

    "title-pt-br":
      "Placas de Vídeo, Notebooks Gamer e PCs Gamer NVIDIA GeForce - Brasil ",
    "description-pt-br":
      "Encontre os melhores produtos e compre placas de vídeo, notebooks, PCs gamer e monitores NVIDIA GeForce na loja oficial da NVIDIA GeForce no Brasil. Conheça mais sobre as placas de vídeo NVIDIA GeForce RTX Série 40.",
    "url-pt-br":
      "https://store.nvidia.com/pt-br/geforce/store/?page=1&limit=9&locale=pt-br",

    "title-fr-fr": "Découvrez les cartes graphiques GeForce RTX",
    "description-fr-fr":
      "Découvrez GeForce RTX. Jouez avec la puissance phénoménale du ray tracing en temps réel.",
    "url-fr-fr": "https://store.nvidia.com/fr-fr/geforce/store/",

    "title-de-de": "Wir stellen vor: GeForce GTX-Grafikkarten",
    "description-de-de":
      "GeForce RTX ist da. Einfach losspielen mit der Macht des Echtzeit-Raytracings.",
    "url-de-de": "https://store.nvidia.com/de-de/geforce/store/",

    "title-de-at": "Wir stellen vor: GeForce GTX-Grafikkarten",
    "description-de-at":
      "GeForce RTX ist da. Einfach losspielen mit der Macht des Echtzeit-Raytracings.",
    "url-de-at": "https://store.nvidia.com/de-at/geforce/store/",

    "title-es-es": "Compra tarjetas gráficas GeForce RTX",
    "description-es-es":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "url-es-es": "https://store.nvidia.com/es-es/geforce/store/",

    "title-es-mx": "Compra tarjetas gráficas GeForce RTX",
    "description-es-mx":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "url-es-mx": "https://store.nvidia.com/es-mx/geforce/store/",

    "title-pl-pl": "Introducing GeForce RTX Graphics Cards",
    "description-pl-pl":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-pl-pl": "https://store.nvidia.com/pl-pl/geforce/store/",

    "title-nl-nl": "Introducing GeForce RTX Graphics Cards",
    "description-nl-nl":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-nl-nl": "https://store.nvidia.com/nl-nl/geforce/store/",

    "title-ru-ru": "Introducing GeForce RTX Graphics Cards",
    "description-ru-ru":
      "GeForce RTX is here. Game on with the power of real-time ray tracing.",
    "url-ru-ru": "https://store.nvidia.com/ru-ru/geforce/store/",

    "title-it-it":
      "Schede grafiche GeForce - La soluzione definitiva per il PC Gaming",
    "description-it-it":
      "Le schede grafiche NVIDIA GeForce sono state concepite per offrire la migliore esperienza di gioco su PC in assoluto e offrono prestazioni spettacolari, 3D immersivo e grafica in alta risoluzione.",
    "url-it-it": "https://store.nvidia.com/it-it/geforce/store/",

    "title-zh-tw": "介紹GeForce RTX 顯示卡",
    "description-zh-tw": "GeForce RTX 來了。使用由Ampere 架構暢玩遊戲。",
    "url-zh-tw": "https://store.nvidia.com/zh-tw/geforce/store/",

    "title-fi-fi":
      "GEFORCE-NÄYTÖNOHJAINTEN, -KANNETTAVIEN JA -KONEIDEN VALIKOIMA - NVIDIA GeForce Store FI",
    "description-fi-fi":
      "Osta NVIDIA GeForce RTX 40 -sarjan tuotteita, 30-sarja, 20-sarjan ja GTX 16 -sarjan näytönohjaimet, pelikannettavat, pöytäkoneet ja muut.",
    "url-fi-fi": "https://store.nvidia.com/fi-fi/geforce/store/",

    "title-da-dk":
      "KØB GRAFIKKORT, BÆRBARE PC'ER OG SYSTEMER MED GEFORCE - NVIDIA GeForce Store DK",
    "description-da-dk":
      "Køb grafikkort, bærbare gaming-pc’er, stationære pc’er m.m. i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "url-da-dk": "https://store.nvidia.com/da-dk/geforce/store/",

    "title-nb-no":
      "KJØP GRAFIKKORT, BÆRBARE PC-ER OG SYSTEMER FRA GEFORCE - NVIDIA GeForce Store NO",
    "description-nb-no":
      "Kjøp grafikkort, bærbare og stasjonære spill-PC-er og mer i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "url-nb-no": "https://store.nvidia.com/nb-no/geforce/store/",

    "title-sv-se":
      "KÖP GEFORCE-GRAFIKKORT, BÄRBARA DATORER OCH SYSTEM - NVIDIA GeForce Store SE",
    "description-sv-se":
      "Köp grafikkort i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien och i GTX 16-serien, bärbara och stationära speldatorer och mycket mer.",
    "url-sv-se": "https://store.nvidia.com/sv-se/geforce/store/",

    "title-en-sg":
      "Shop GeForce Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store",
    "description-en-sg":
      "Buy NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktops, Studio Laptops and more from the official NVIDIA Store. Shop RTX 40 series, 30 series, 20 series, GTX 16 series products now.",
    "url-en-sg": "https://store.nvidia.com/en-sg/geforce/store/",

    "title-en-my":
      "Buy Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store – Malaysia",
    "description-en-my":
      "Buy GeForce Graphics Cards, Laptops, Desktop, Monitor, and Mice NVIDIA Store – Malaysia. Checkout our all-new range of GeForce products now!",
    "url-en-my": "https://store.nvidia.com/en-my/geforce/store/",

    "title-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 – 대한민국",
    "description-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 및 모니터를 NVIDIA GeForce 공식 스토어에서 구매하세요 - 대한민국. GeForce RTX 40 시리즈 GPU 에 대해 더 알아보세요",
    "url-ko-kr":
      "https://store.nvidia.com/ko-kr/geforce/store/?page=1&limit=9&locale=ko-kr",

    "title-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ノートパソコン、デスクトップ – 日本",
    "description-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ラップトップ、デスクトップ、モニターを NVIDIA GeForce 公式ストアから購入します。 GeForce RTX 40 シリーズ GPU の詳細については、こちらをご覧ください。",
    "url-ja-jp":
      "https://store.nvidia.com/ja-jp/geforce/store/?page=1&limit=9&locale=ja-jp",
  };

  private configTwitter = {
    card: "summary",
    site: "@NVIDIA",
    creator: "@nvidiageforce",
    image:
      "https://store.nvidia.com/en-us/assets/images/carousel/geforce-ada-4090-background-image-spec2-bb300_300-l.jpg",
    "title-en-us": "GeForce RTX Graphics Cards are Here",
    "description-en-us":
      "Introducing GeForce RTX graphics cards with real time ray tracing. Game on!",
    "url-en-us": "https://store.nvidia.com/en-us/geforce/store/",

    "title-en-in":
      "NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop – India",
    "description-en-in":
      "Shop NVIDIA GeForce graphics cards, gaming laptops, desktop and monitor from the official NVIDIA GeForce store - India. Know more about GeForce RTX 40 series GPUs.",
    "url-en-in":
      "https://store.nvidia.com/en-in/geforce/store/?page=1&limit=9&locale=en-in",

    "title-en-ph": "GeForce RTX Graphics Cards are Here",
    "description-en-ph":
      "Introducing GeForce RTX graphics cards with real time ray tracing. Game on!",
    "url-en-ph": "https://store.nvidia.com/en-ph/geforce/store/",

    "title-id-id": "Beli Kartu Grafis, Laptop, dan Sistem | NVIDIA GeForce Store Indonesia",
    "description-id-id":
      "Beli Kartu Grafis, Laptop Gaming, Desktop, Studio Laptop NVIDIA GeForce dan lainnya dari Toko resmi NVIDIA. Beli produk RTX 40 series, 30 series, 20 series, GTX 16 series sekarang.",
    "url-id-id": "https://store.nvidia.com/id-id/geforce/store/?page=1&limit=9&locale=id-id",

    "title-vi-vn": "Mua card màn hình, laptop và máy bộ PC | NVIDIA GeForce Store Việt Nam",
    "description-vi-vn":
      "Mua card màn hình NVIDIA GeForce, Laptop Gaming, Máy tính để bàn, Laptop Studio và nhiều món khác từ cửa hàng NVIDIA Store chính thức. Hãy chọn mua ngay các dòng card đồ họa thế hệ RTX 40 series, 30 series, 20 series, GTX 16 series ở đây.",
    "url-vi-vn": "https://store.nvidia.com/vi-vn/geforce/store/",
    
    "title-th-th":
      "ซื้อกราฟิกการ์ด แล็ปท็อป และเดสก์ท็อป | NVIDIA GeForce Store ประเทศไทย",
    "description-th-th":
      "ซื้อกราฟิกการ์ด NVIDIA GeForce เกมมิ่งแล็ปท็อป เดสก์ท็อป สตูดิโอแล็ปท็อป และอื่นๆ อีกมากมายจากร้าน NVIDIA Store เลือกซื้อสินค้า RTX 40 ซีรีส์, 30 ซีรีส์, 20 ซีรีส์, และ GTX 16 ซีรีส์ ได้ที่นี่",
    "url-th-th":
      "https://store.nvidia.com/th-th/geforce/store/?page=1&limit=9&locale=th-th",

    "title-en-gb": "GeForce RTX Graphics Cards are Here",
    "description-en-gb":
      "Introducing GeForce RTX graphics cards with real time ray tracing. Game on!",
    "url-en-gb": "https://store.nvidia.com/en-gb/geforce/store/",

    "title-pt-br":
      "Placas de Vídeo, Notebooks Gamer e PCs Gamer NVIDIA GeForce - Brasil",
    "description-pt-br":
      "Encontre os melhores produtos e compre placas de vídeo, notebooks, PCs gamer e monitores NVIDIA GeForce na loja oficial da NVIDIA GeForce no Brasil. Conheça mais sobre as placas de vídeo NVIDIA GeForce RTX Série 40.",
    "url-pt-br":
      "https://store.nvidia.com/pt-br/geforce/store/?page=1&limit=9&locale=pt-br",

    "title-fr-fr": "Les cartes graphiques GeForce RTX sont disponibles",
    "description-fr-fr":
      "Cartes graphiques GeForce RTX avec ray tracing en temps réel. À vous de jouer !",
    "url-fr-fr": "https://store.nvidia.com/fr-fr/geforce/store/",

    "title-de-de": "GeForce RTX-Grafikkarten sind da",
    "description-de-de":
      "Wir stellen vor: GeForce RTX-Grafikkarten mit Echtzeit-Raytracing. Das Spiel kann beginnen!",
    "url-de-de": "https://store.nvidia.com/de-de/geforce/store/",

    "title-de-at": "GeForce RTX-Grafikkarten sind da",
    "description-de-at":
      "Wir stellen vor: GeForce RTX-Grafikkarten mit Echtzeit-Raytracing. Das Spiel kann beginnen!",
    "url-de-at": "https://store.nvidia.com/de-at/geforce/store/",

    "title-es-es": "Compra tarjetas gráficas GeForce RTX",
    "description-es-es":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "url-es-es": "https://store.nvidia.com/es-es/geforce/store/",

    "title-es-mx": "Compra tarjetas gráficas GeForce RTX",
    "description-es-mx":
      "Llega GeForce RTX. Sigue jugando con GeForce RTX 2080 Ti, 2080 y 2070 con tecnología de trazado de rayos en tiempo real.",
    "url-es-mx": "https://store.nvidia.com/es-mx/geforce/store/",

    "title-pl-pl": "GeForce RTX Graphics Cards are Here",
    "description-pl-pl":
      "Introducing GeForce RTX graphics cards with real time ray tracing. Game on!",
    "url-pl-pl": "https://store.nvidia.com/pl-pl/geforce/store/",

    "title-nl-nl": "GeForce RTX Graphics Cards are Here",
    "description-nl-nl":
      "Introducing GeForce RTX graphics cards with real time ray tracing. Game on!",
    "url-nl-nl": "https://store.nvidia.com/nl-nl/geforce/store/",

    "title-it-it":
      "Schede grafiche GeForce - La soluzione definitiva per il PC Gaming",
    "description-it-it":
      "Le schede grafiche NVIDIA GeForce sono state concepite per offrire la migliore esperienza di gioco su PC in assoluto e offrono prestazioni spettacolari, 3D immersivo e grafica in alta risoluzione.",
    "url-it-it": "https://store.nvidia.com/nl-nl/geforce/store/",

    "title-zh-tw": "GeForce RTX顯示卡來了。",
    "description-zh-tw":
      "介紹由 NVIDIA 第二代 RTX Ampere 架構支援的GeForce RTX 顯示卡。終極致勝",
    "url-zh-tw": "https://store.nvidia.com/zh-tw/geforce/store/",

    "title-fi-fi":
      "GEFORCE-NÄYTÖNOHJAINTEN, -KANNETTAVIEN JA -KONEIDEN VALIKOIMA - NVIDIA GeForce Store FI",
    "description-fi-fi":
      "Osta NVIDIA GeForce RTX 40 -sarjan tuotteita, 30-sarja, 20-sarjan ja GTX 16 -sarjan näytönohjaimet, pelikannettavat, pöytäkoneet ja muut.",
    "url-fi-fi": "https://store.nvidia.com/fi-fi/geforce/store/",

    "title-da-dk":
      "KØB GRAFIKKORT, BÆRBARE PC'ER OG SYSTEMER MED GEFORCE - NVIDIA GeForce Store DK",
    "description-da-dk":
      "Køb grafikkort, bærbare gaming-pc’er, stationære pc’er m.m. i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "url-da-dk": "https://store.nvidia.com/da-dk/geforce/store/",

    "title-nb-no":
      "KJØP GRAFIKKORT, BÆRBARE PC-ER OG SYSTEMER FRA GEFORCE - NVIDIA GeForce Store NO",
    "description-nb-no":
      "Kjøp grafikkort, bærbare og stasjonære spill-PC-er og mer i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien og GTX 16-serien.",
    "url-nb-no": "https://store.nvidia.com/nb-no/geforce/store/",

    "title-sv-se":
      "KÖP GEFORCE-GRAFIKKORT, BÄRBARA DATORER OCH SYSTEM - NVIDIA GeForce Store SE",
    "description-sv-se":
      "Köp grafikkort i NVIDIA GeForce RTX 40-serien, 30-serien, 20-serien och i GTX 16-serien, bärbara och stationära speldatorer och mycket mer.",
    "url-sv-se": "https://store.nvidia.com/sv-se/geforce/store/",

    "title-en-sg":
      "Shop GeForce Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store",
    "description-en-sg":
      "Buy NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktops, Studio Laptops and more from the official NVIDIA Store. Shop RTX 40 series, 30 series, 20 series, GTX 16 series products now.",
    "url-en-sg": "https://store.nvidia.com/en-sg/geforce/store/",

    "title-en-my":
      "Buy Graphics Cards, Laptops, and Systems | NVIDIA GeForce Store – Malaysia",
    "description-en-my":
      "Buy GeForce Graphics Cards, Laptops, Desktop, Monitor, and Mice NVIDIA Store – Malaysia. Checkout our all-new range of GeForce products now!",
    "url-en-my": "https://store.nvidia.com/en-my/geforce/store/",

    "title-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 – 대한민국",
    "description-ko-kr":
      "NVIDIA GeForce 그래픽 카드, 게이밍 노트북, 데스크톱 및 모니터를 NVIDIA GeForce 공식 스토어에서 구매하세요 - 대한민국. GeForce RTX 40 시리즈 GPU 에 대해 더 알아보세요",
    "url-ko-kr":
      "https://store.nvidia.com/ko-kr/geforce/store/?page=1&limit=9&locale=ko-kr",

    "title-ja-jp":
      "NVIDIA GeForce グラフィックス カード、ゲーム用ノートパソコン、デスクトップ – 日本",
    "description-ja-jp":
      "NVIDIA GeForce 公式ストア - 日本から NVIDIA GeForce グラフィックス カード、ゲーミング ラップトップ、デスクトップ、モニターを購入してください。 GeForce RTX 40 シリーズ GPU の詳細をご覧ください。",
    "url-ja-jp":
      "https://store.nvidia.com/ja-jp/geforce/store/?page=1&limit=9&locale=ja-jp",
  };

  constructor(
    private meta: Meta,
    private title: Title,
    @Inject(DOCUMENT) private doc,
    private productService: ProductService
  ) {}
  registerCountry(lang) {
    let langCode = lang.split("-")[1].toUpperCase();
    i18nIsoCountries.registerLocale(
      require("i18n-iso-countries/langs/en.json")
    );
    let value = "";
    value = i18nIsoCountries.getName("US", "en");
    value = i18nIsoCountries.getName(langCode, "en");
    return value;
  }

  generateTags(locale, isCompare, product_sku) {
    if (!isCompare) {
      this.title.setTitle(`${this.indexHTML[`title-${locale}`]}`);
      this.meta.updateTag({
        name: "description",
        content: `${this.indexHTML[`description-${locale}`]}`,
      });

      if (product_sku !== "product") {
        let productSku = product_sku;
        let metadiscription =
          "Buy " +
          productSku +
          " from NVIDIA GeForce Store. Checkout description and buying options for NVIDIA  " +
          productSku +
          ".";
        this.title.setTitle(productSku);
        // this.titleService.setTitle(title);
        this.meta.updateTag({
          name: "description",
          content: metadiscription,
        });
        this.removeLangHref();
        this.removeCanonicalURL();
        this.createLinkForCanonicalURL(locale);
        // console.log("-----productSku----->", product_sku,"-------h>", metadiscription);
      }
      if (product_sku === "product") {
        let pdpUrlCombo = window.location.href;
        let singlePageidentity = pdpUrlCombo.split("geforce/")[1];
        // let doublePlacePageidentity = pdpUrlCombo.split('geforce/')[2];

        if (!(singlePageidentity.indexOf("store") > -1)) {
          let storeSeoTitle =
            "NVIDIA GeForce Graphics Cards, Gaming Laptops, Desktop and Monitor - " +
            this.registerCountry(locale);
          let spectrum3sn4000SeoTitle =
            "NVIDIA Spectrum-3 SN4000 - NVIDIA GeForce Store";
          let spectrum2sn2000SeoTitle =
            "NVIDIA Spectrum SN2000 - NVIDIA GeForce Store";
          let contactSeoTitle = "Contact Us - NVIDIA GeForce Store";
          let pocSeoTitle =
            "NVIDIA Proof of Concept and Development Kits - NVIDIA GeForce Store";
          let getQuoteSeoTitle =
            "Request Pricing | Get a Quote - NVIDIA GeForce Store";
          let bluefieldDpuSeoTitle =
            "NVIDIA BlueField DPU Development Hardware - NVIDIA GeForce Store";

          let storeSeoDes =
            "Show NVIDIA GeForce graphics cards, gaming laptops, desktop and monitor from the official NVIDIA GeForce store - " +
            this.registerCountry(locale) +
            ". Know more about GeForce RTX 40 series GPUs.";
          let spectrum3sn4000SeoDes =
            "Optimize Utilization and Efficiency with Cost-Effective NVIDIA Spectrum-3 SN4000 Open Ethernet. NVIDIA Spectrum-3 SN4000 is available now for qualified customers.";
          let spectrum2sn2000SeoDes =
            "NVIDIA® Spectrum® SN2000 provides the highest performance with 1/10/25/40/50/100GbE speeds. NVIDIA® Spectrum® SN2000 is available now for qualified customers.";
          let contactSeoDes =
            "Contact the NVIDIA GeForce Store with any questions on NVIDIA GeForce products. Please call US Toll-Free: 855-897-1098 or Intl: +1-512-220-1515 or fill-up the contact form.";
          let pocSeoDes =
            "NVIDIA offers proof of concept and development kits which are designed to prove the performance and value of NVIDIA GeForce platforms. Explore the NVIDIA POC kits Now.";
          let getQuoteSeoDes =
            "Fill the form to request more information or to schedule a follow-up to discuss your project with a knowledgeable NVIDIA GeForce representative. Call us at 855-897-1098 or Intl: +1-512-220-1515.";
          let bluefieldDpuSeoDes =
            "Accelerate Deployment of BlueField and DOCA Applications with NVIDIA BlueField DPU Development Hardware. NVIDIA BlueField DPU Development Hardware is available now for qualified customers.";

          let query_str_arr = window.location.search
            .substring(1, window.location.search.length)
            .split("&");
          if (window.location.pathname.indexOf("/geforce/store/") > -1) {
            this.title.setTitle(storeSeoTitle);
            this.meta.updateTag({
              name: "description",
              content: storeSeoDes,
            });
          }
          // if (singlePageidentity === "contact/") {
          //   this.title.setTitle(contactSeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: contactSeoDes,
          //   });
          // }
          // if (singlePageidentity === "poc/") {
          //   this.title.setTitle(pocSeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: pocSeoDes,
          //   });
          // }
          // if (
          //   singlePageidentity === "poc/bluefield-dpu-development-hardware/"
          // ) {
          //   this.title.setTitle(bluefieldDpuSeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: bluefieldDpuSeoDes,
          //   });
          // }
          // if (
          //   singlePageidentity ===
          //   "poc/spectrum-sn2000-open-ethernet-switches-poc/"
          // ) {
          //   this.title.setTitle(spectrum2sn2000SeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: spectrum2sn2000SeoDes,
          //   });
          // }

          // if (
          //   singlePageidentity ===
          //   "poc/spectrum-3-sn4000-open-ethernet-switches-poc/"
          // ) {
          //   this.title.setTitle(spectrum3sn4000SeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: spectrum3sn4000SeoDes,
          //   });
          // }
          // if (singlePageidentity === "request-pricing-get-a-quote/") {
          //   this.title.setTitle(getQuoteSeoTitle);
          //   this.meta.updateTag({
          //     name: "description",
          //     content: getQuoteSeoDes,
          //   });
          // }
        }

        this.createLangHref();
        this.removeCanonicalURL();
        this.createLinkForCanonicalURL(locale);
      }
    }
    if (isCompare) {
      this.title.setTitle(`${this.indexHTML[`title-compare-${locale}`]}`);
      this.meta.updateTag({
        name: "description",
        content: `${this.indexHTML[`description-compare-${locale}`]}`,
      });
      this.removeCanonicalURL();
      this.createLinkForCanonicalURL(locale);
    }

    if (!isCompare) {
      let productSku = product_sku;
      let metadiscription =
        "Buy " +
        productSku +
        " from NVIDIA GeForce Store. Checkout description and buying options for " +
        productSku;

      let storeSeoTwitterTitle =
        "Shop NVIDIA GeForce Products - Ethernet and InfiniBand";
      let spectrum3sn4000SeoTwitterTitle =
        "NVIDIA Spectrum-3 SN4000 - NVIDIA GeForce Store";
      let spectrum2sn2000SeoTwitterTitle =
        "NVIDIA Spectrum SN2000 - NVIDIA GeForce Store";
      let contactSeoTwitterTitle = "Contact Us - NVIDIA GeForce Store";
      let pocSeoTwitterTitle =
        "NVIDIA Proof of Concept and Development Kits - NVIDIA GeForce Store";
      let getQuoteSeoTwitterTitle =
        "Request Pricing | Get a Quote - NVIDIA GeForce Store";
      let bluefieldDpuSeoTwitterTitle =
        "NVIDIA BlueField DPU Development Hardware - NVIDIA GeForce Store";

      let storeSeoTwitterDes =
        "NVIDIA GeForce Store offers online shopping of Ethernet and InfiniBand. Buy now Adapter Cards, DPU, Interconnect, Switches System and much more.";
      let spectrum3sn4000SeoTwitterDes =
        "Optimize Utilization and Efficiency with Cost-Effective NVIDIA Spectrum-3 SN4000 Open Ethernet. NVIDIA Spectrum-3 SN4000 is available now for qualified customers.";
      let spectrum2sn2000SeoTwitterDes =
        "NVIDIA® Spectrum® SN2000 provides the highest performance with 1/10/25/40/50/100GbE speeds. NVIDIA® Spectrum® SN2000 is available now for qualified customers.";
      let contactSeoTwitterDes =
        "Contact the NVIDIA GeForce Store with any questions on NVIDIA GeForce products. Please call US Toll-Free: 855-897-1098 or Intl: +1-512-220-1515 or fill-up the contact form.";
      let pocSeoTwitterDes =
        "NVIDIA offers proof of concept and development kits which are designed to prove the performance and value of NVIDIA GeForce platforms. Explore the NVIDIA POC kits Now.";
      let getQuoteSeoTwitterDes =
        "Fill the form to request more information or to schedule a follow-up to discuss your project with a knowledgeable NVIDIA GeForce representative. Call us at 855-897-1098 or Intl: +1-512-220-1515.";
      let bluefieldDpuSeoTwitterDes =
        "Accelerate Deployment of BlueField and DOCA Applications with NVIDIA BlueField DPU Development Hardware. NVIDIA BlueField DPU Development Hardware is available now for qualified customers.";

      let pdpUrlCombo = window.location.href;
      let singlePageidentity = pdpUrlCombo.split("geforce/")[1];

      this.removeCanonicalURL();
      this.createLinkForCanonicalURL(locale);
      this.meta.updateTag({
        property: "og:site_name",
        content: this.configOG.name,
      });
      this.meta.updateTag({ property: "og:type", content: this.configOG.type });
      this.meta.updateTag({
        property: "og:url",
        content: window.location.href,
      });
      this.meta.updateTag({
        property: "og:title",
        content: `${this.configOG[`title-${locale}`]}`,
      });
      this.meta.updateTag({
        property: "og:description",
        content: `${this.configOG[`description-${locale}`]}`,
      });
      this.meta.updateTag({
        property: "og:image",
        content: this.configOG.image,
      });
      this.meta.updateTag({
        name: "twitter:title",
        content: `${this.configTwitter[`title-${locale}`]}`,
      });
      this.meta.updateTag({
        property: "twitter:description",
        content: `${this.configTwitter[`description-${locale}`]}`,
      });
      this.meta.updateTag({
        name: "twitter:card",
        content: this.configTwitter.card,
      });
      this.meta.updateTag({
        name: "twitter:site",
        content: this.configTwitter.site,
      });
      this.meta.updateTag({
        name: "twitter:creator",
        content: this.configTwitter.creator,
      });

      if (product_sku !== "product") {
        this.meta.updateTag({
          name: "twitter:title",
          content: productSku,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: metadiscription,
        });
        this.meta.updateTag({
          property: "og:title",
          content: productSku,
        });
        this.meta.updateTag({
          property: "og:description",
          content: metadiscription,
        });
      }

      let query_str_arr = window.location.search
        .substring(1, window.location.search.length)
        .split("&");
      if (
        (window.location.pathname === "/en-us/geforce/store/" &&
          query_str_arr.length > 3) ||
        window.location.pathname === "/en-us/geforce/store/"
      ) {
        this.meta.updateTag({
          name: "twitter:title",
          content: storeSeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: storeSeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: storeSeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: storeSeoTwitterDes,
        });
      }
      // if(singlePageidentity === "store/?page=1&limit=9&locale=en-us"){
      //   this.meta.updateTag({
      //     name: "twitter:title",
      //     content: storeSeoTwitterTitle
      //   });
      //   this.meta.updateTag({
      //   name: "twitter:description",
      //   content: storeSeoTwitterDes
      //   });
      //   this.meta.updateTag({
      //   property: "og:title",
      //   content: storeSeoTwitterTitle
      //   });
      //   this.meta.updateTag({
      //     property: "og:description",
      //     content: storeSeoTwitterDes
      //   });
      // }

      if (singlePageidentity === "contact/") {
        this.meta.updateTag({
          name: "twitter:title",
          content: contactSeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: contactSeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: contactSeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: contactSeoTwitterDes,
        });
      }
      if (singlePageidentity === "poc/") {
        this.meta.updateTag({
          name: "twitter:title",
          content: pocSeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: pocSeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: pocSeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: pocSeoTwitterDes,
        });
      }
      if (singlePageidentity === "poc/bluefield-dpu-development-hardware/") {
        this.meta.updateTag({
          name: "twitter:title",
          content: bluefieldDpuSeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: bluefieldDpuSeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: bluefieldDpuSeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: bluefieldDpuSeoTwitterDes,
        });
      }
      if (
        singlePageidentity === "poc/spectrum-sn2000-open-ethernet-switches-poc/"
      ) {
        this.meta.updateTag({
          name: "twitter:title",
          content: spectrum2sn2000SeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: spectrum2sn2000SeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: spectrum2sn2000SeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: spectrum2sn2000SeoTwitterDes,
        });
      }
      if (
        singlePageidentity ===
        "poc/spectrum-3-sn4000-open-ethernet-switches-poc/"
      ) {
        this.meta.updateTag({
          name: "twitter:title",
          content: spectrum3sn4000SeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: spectrum3sn4000SeoTwitterDes,
        });
        this.meta.updateTag({
          property: "og:title",
          content: spectrum3sn4000SeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: spectrum3sn4000SeoTwitterDes,
        });
      }
      if (singlePageidentity === "request-pricing-get-a-quote/") {
        this.meta.updateTag({
          name: "twitter:title",
          content: getQuoteSeoTwitterTitle,
        });
        this.meta.updateTag({
          name: "twitter:description",
          content: getQuoteSeoTwitterDes,
          // content: `${this.configTwitter[`description-${locale}`]}`
        });
        this.meta.updateTag({
          property: "og:title",
          content: getQuoteSeoTwitterTitle,
        });
        this.meta.updateTag({
          property: "og:description",
          content: getQuoteSeoTwitterDes,
          // content: `${this.configOG[`description-${locale}`]}`
        });
      }
      this.meta.updateTag({
        name: "twitter:url",
        content: window.location.href,
      });

      this.meta.updateTag({
        name: "twitter:image",
        content: this.configTwitter.image,
      });
      this.meta.updateTag({
        name: "keywords",
        content:
          "Data center, GeForce, Mellanox, NVIDIA GeForce, InfiniBand, ethernet, adapters, SmartNIC, smart adapters, NICs, AI, Artificial Intelligence, HPC, High performance computing",
      });
    }

    if (isCompare) {
      this.meta.removeTag("property='og:site_name'");
      this.meta.removeTag("property='og:type'");
      this.meta.removeTag("property='og:url'");
      this.meta.removeTag("property='og:title'");
      this.meta.removeTag("property='og:description'");
      this.meta.removeTag("property='og:image'");

      this.meta.removeTag("name='twitter:card'");
      this.meta.removeTag("name='twitter:site'");
      this.meta.removeTag("name='twitter:creator'");
      this.meta.removeTag("name='twitter:title'");
      this.meta.removeTag("name='twitter:url'");
      this.meta.removeTag("name='twitter:description'");
      this.meta.removeTag("name='twitter:image'");

      this.meta.removeTag("name='keywords'");
    }
  }

  createLinkForCanonicalURL(locale) {
    let link: HTMLLinkElement = this.doc.createElement("link");
    link.setAttribute("rel", "canonical");
    this.doc.head.appendChild(link);
    link.href = window.location.href;
    // console.log("locale---->", locale,"---link-->", link.href)
  }

  createLangHref() {
    let langtext =
      '<link rel="alternate" hreflang="en-us" href="https://store.nvidia.com/en-us/geforce/store/"><link rel="alternate" hreflang="pt-br" href="https://store.nvidia.com/pt-br/geforce/store/"><link rel="alternate" hreflang="tr-tr" href="https://www.nvidia.com/tr-tr/geforce/buy/"><link rel="alternate" hreflang="sv-se" href="https://store.nvidia.com/sv-se/geforce/store/"><link rel="alternate" hreflang="ru-ru" href="https://www.nvidia.ru/geforce/buy/"><link rel="alternate" hreflang="pl-pl" href="https://store.nvidia.com/pl-pl/geforce/store/"><link rel="alternate" hreflang="nl-nl" href="https://store.nvidia.com/nl-nl/geforce/store/"><link rel="alternate" hreflang="it-it" href="https://store.nvidia.com/it-it/geforce/store/"><link rel="alternate" hreflang="fr-be" href="https://www.nvidia.com/fr-be/geforce/buy/"><link rel="alternate" hreflang="fr-fr" href="https://store.nvidia.com/fr-fr/geforce/store/"><link rel="alternate" hreflang="fi-fi" href="https://store.nvidia.com/fi-fi/geforce/store/"><link rel="alternate" hreflang="es-es" href="https://store.nvidia.com/es-es/geforce/store/"><link rel="alternate" hreflang="de-at" href="https://store.nvidia.com/de-at/geforce/store/"><link rel="alternate" hreflang="de-de" href="https://store.nvidia.com/de-de/geforce/store/"><link rel="alternate" hreflang="da-dk" href="https://store.nvidia.com/da-dk/geforce/store/"><link rel="alternate" hreflang="cs-cz" href="https://www.nvidia.com/cs-cz/geforce/buy/"><link rel="alternate" hreflang="en-gb" href="https://store.nvidia.com/en-gb/geforce/store/"><link rel="alternate" hreflang="en-ca" href="https://store.nvidia.com/en-ca/geforce/store/"><link rel="alternate" hreflang="it-it" href="https://store.nvidia.com/it-it/geforce/store/"><link rel="alternate" hreflang="en-ph" href="https://store.nvidia.com/en-ph/geforce/store/"><link rel="alternate" hreflang="nl-nl" href="https://store.nvidia.com/nl-nl/geforce/store/"><link rel="alternate" hreflang="fr-ca" href="https://store.nvidia.com/fr-ca/geforce/store/"><link rel="alternate" hreflang="en-au" href="https://store.nvidia.com/en-au/geforce/store/"><link rel="alternate" hreflang="nb-no" href="https://store.nvidia.com/nb-no/geforce/store/"><link rel="alternate" hreflang="ro-ro" href="https://www.nvidia.com/ro-ro/geforce/buy/"><link rel="alternate" hreflang="en-my" href="https://store.nvidia.com/en-my/geforce/store/"><link rel="alternate" hreflang="ko-kr" href="https://store.nvidia.com/ko-kr/geforce/store/"><link rel="alternate" hreflang="th-th" href="https://store.nvidia.com/th-th/geforce/store/"><link rel="alternate" hreflang="x-default" href="https://store.nvidia.com/en-us/geforce/store/">';
    $("head").append(langtext);
  }
  removeLangHref() {
    var links = $("link");
    $("link[rel=alternate]").each(function (i, j) {
      // Print the value currently in
      // the input box
      j.remove();
    });
    // for (var i = 0; i < links.length; i++) {
    //   var link = links[i];
    //   console.log("LangHref===>",link.attr('href'))
    //   if (link.getAttribute("rel").indexOf("alternate") > -1) {
    //     // console.log("LangHref===>",link.getAttribute('hreflang'))
    //     // link.remove();
    //     links.removeChild(link);
    //   }
    // }
  }
  removeCanonicalURL() {
    var links = this.doc.head.getElementsByTagName("link");
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute("rel").indexOf("canonical") != -1) {
        link.remove();
      }
    }
  }
}

